import * as React     from 'react';
import PropTypes      from 'prop-types';
import InputContainer from './input-container';

export default class NumberFieldContainer extends React.Component {
	render() {
		const value = this.props.value || '';
		return <InputContainer {...this.props} type="number" value={value} />;
	}
}

NumberFieldContainer.propTypes = {
	disabled    : PropTypes.bool,
	id          : PropTypes.string,
	label       : PropTypes.string,
	loading     : PropTypes.bool,
	max         : PropTypes.number,
	min         : PropTypes.number,
	name        : PropTypes.string,
	onChange    : PropTypes.func,
	placeholder : PropTypes.string,
	required    : PropTypes.bool,
	step        : PropTypes.number,
	value       : PropTypes.number,
}


// WEBPACK FOOTER //
// ./src/component/form/input/numberfield-container.js